import Vue from 'vue';
import Vuex from 'vuex';
import uuidv4 from 'uuid/v4';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isMenuShown: false,
    user: JSON.parse(localStorage.getItem('user')),
    signOutModal: {
      isShown: false,
      text: null,
    },
    isBackgroundBlurred: false,
    tabId: null,
  },
  mutations: {
    toggleMenu: state => {
      state.isMenuShown = !state.isMenuShown;
    },
    hideMenu: state => {
      state.isMenuShown = false;
    },
    showMenu: state => {
      state.isMenuShown = true;
    },
    setUser: (state, payload) => {
      state.user = payload;
      localStorage.setItem('user', JSON.stringify(payload));
    },
    logOut: state => {
      state.user = null;

      localStorage.removeItem('jwtacc');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    },
    setBackgroundBlur: (state, payload) => {
      state.isBackgroundBlurred = payload;
    },
    toggleSignOutModal: (state, { isShown, text }) => {
      state.signOutModal.isShown = isShown;
      state.signOutModal.text = text;
    },
    updateActiveTab: state => {
      if (!state.tabId) {
        state.tabId = uuidv4();
      }
      localStorage.setItem('activeTab', state.tabId);
    },
  },
});

export default store;
